import { ApiSubdomainEnv } from './api-subdomain-env.type';

export const apiSubdomainEnv: ApiSubdomainEnv = {
  useApiSubdomain: true,
};
